export class RDMusicElement {

  title: string;
  channel: string;
  url: string;
  type: string;
  imageurl: string;

  constructor() { }

}
